import styled, { css } from 'styled-components';
import { brandIsPh } from '@/shared/config/brand-by-target.mjs';

export const ButtonWrapper = styled.div`
  gap: 8px;
  margin-top: 24px;
  margin-bottom: 20px;
  display: none;
  width: 100%;
  box-sizing: border-box;

  & > span {
    width: 100%;
  }

  @media (max-width: 768px) {
    display: flex;
    padding: 0 18px;
    min-height: 40px;

    ${brandIsPh &&
    css`
      margin-top: 12px;
      margin-bottom: 12px;
      padding: 0 12px;
      min-height: 42px;
    `}
  }
`;
